import db from "../../../../database";
import moment from "moment";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { upsertTableStatus, cancelFBOrder, upsertTableReservation, upsertFBOrder, getFBOrder } from "../../../../services/index";
import { v4 as uuidv4 } from "uuid";

const SyncData = async (item, type, setLoading, status, IPOrder) => {
  const serverUrl = process.env.REACT_APP_serverUrl;
  const authHeaders = getOAuthHeaders();
  let token;
  if (authHeaders) {
    token = authHeaders.access_token;
  }
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  if (type === "upsertTableStatus") {
    const paramsInput = {
      query: `mutation {
                  upsertTableStatus(tableStatus: {
                    cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
                    fbtableStatusId: "${item.fbtableStatusId}"
                    fbTableId: "${item.cwrFbTableId}"
                    fbSectionId: "${item.cwrFbsectionId}"
                    status: "${item.statusType}"
                    guests: ${item.noOfPersons || 0}
                    guestName: "${item.guestName || ""}"
                    guestType: "${item.guestType || ""}"
                    referredBy: "${item.referredBy || ""}"
                    salesRepId: ${item.waiter ? `"${item.waiter}"` : null}
                   }) { 
                status
                message   
                }
                }`,
    };
    try {
      const response = await upsertTableStatus(paramsInput);
      if (response.data.data.upsertTableStatus.status === "200") {
        let allTableData = await db.tableData.toArray();
        let data = [];
        allTableData.map((ele) => {
          if (item.cwrFbTableId === ele.cwrFbTableId && item.statusType === "OPN") {
            ele.ordered = "N";
            ele.statusType = "OPN";
            ele.color = "#a7c957";
            ele.tabbleSync = "Y";
          }
          data.push(ele);
        });
        await db.tableData.clear();
        await db.tableData.bulkPut(data);
        // await db.tableData.put(item, item.cwrFbTableId);
      }
    } catch (err) {
      console.log(err);
    }
  } else if (type === "cancelItem") {
    const cancelItemsData = {
      query: `mutation {
                cancelFBOrder(fbOrder: {
                  fbOrderId:"${item.fbOrderId}"
                  lines:[${item.cancelItems}]
                 }) { 
              status
              message   
              }
              }`,
    };
    await cancelFBOrder(cancelItemsData);
  } else if (type === "reservation") {
    const paramsInput = {
      query: `mutation {
              upsertTableReservation(tableReservation: {
                cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
                fbTableReservationId: "${item.uniqueId}"
                fbTableId: "${item.cwrFbTableId}"
                fbSectionId: "${item.cwrFbsectionId}"
                customerName: "${item.name === undefined ? "" : item.name}"
                noOfPeople: "${item.noOfPersons}"
                contactNo: "${item.mobile === undefined ? "" : item.mobile}"
                guestType: "${item.guestType}"
                referredBy: "${item.referredBy === undefined ? "" : item.referredBy}"
                resDate: "${moment(item.time).format("YYYY-MM-DD")}"
                resTime: "${moment(item.time).format("YYYY-MM-DD HH:mm:ss")}"
               }) { 
            status
            message   
            }
            }`,
    };
    await upsertTableReservation(paramsInput);
  } else if (type === "upsertFbOrder") {
    const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
    const cartWithoutItems = { ...cartDetails };
    delete cartWithoutItems.items;
    const cartMetaValue = JSON.stringify(JSON.stringify(cartWithoutItems));
    const fbOrderMetaId = uuidv4().replace(/-/g, "").toUpperCase();

    let metaString = "";
    if (IPOrder) {
      metaString = `[
        {
      fbOrderMetaId: "${fbOrderMetaId}"
      key: "cartDetails"
      value: ${cartMetaValue}
    },
      ]`;
    } else {
      metaString = "[]"; // empty meta when not IP order
    }
    const fbOrders = JSON.parse(localStorage.getItem("getFBOrderData") || "[]");
    db.fbOrderData
      .where("fbOrderSync")
      .equals("N")
      .toArray()
      .then(async (order) => {
        if (order.length > 0) {
          for (let i = 0; i < order.length; i += 1) {
            let orderLines;
            if (Array.isArray(order[i].lines) && typeof order[i].lines[0] === "object" && !Array.isArray(order[i].lines[0])) {
              orderLines = JSON.stringify(order[i].lines).replace(/"(\w+)":/g, "$1:");
            } else {
              orderLines = order[i].lines;
            }
            const filteredOrders = Array.isArray(fbOrders) ? fbOrders.filter((o) => o.fbTableId === order[i].cwrFbTableId || o.fbTableId === order[i].fbTableId) : [];
            const fbSectionIdValue = order[i]?.cwrFbsectionId || order[i]?.fbSectionId || filteredOrders[0]?.fbSectionId;
            const paramsInput = {
              query: `mutation {
                          upsertFBOrder(order: {
                            cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
                            fbOrderId: "${order[i].fbOrderId}"
                            fbTableId: "${order[i]?.cwrFbTableId || order[i]?.fbTableId}"
                            fbSectionId: ${fbSectionIdValue ? `"${fbSectionIdValue}"` : null}
                            sOrderId: null
                            isCanceled: "N"
                            orderNo: "${filteredOrders[0]?.orderNo || (localStorage.getItem("orderId") === null ? 1 : localStorage.getItem("orderId"))}"
                            guestName: ${order[i]?.guestName === undefined ? null : `"${order[i].guestName}"`}
                            guestType: ${order[i]?.guestType === undefined ? null : `"${order[i].guestType}"`}
                            referredBy: ${order[i]?.referredBy === undefined ? null : `"${order[i].referredBy}"`}
                            date: "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"
                            status: "${order[i].fbOrderStatus}"
                            salesRepId: ${order[i]?.waiter === null || order[i]?.waiter === undefined || order[i]?.waiter === "" ? null : `"${order[i]?.waiter}"`}
                            guests: ${order[i]?.noOfPersons ? order[i].noOfPersons : null}
                            lines: ${typeof orderLines === "string" && orderLines.trim().startsWith("[") ? orderLines : `[${orderLines}]`}
                            meta: ${metaString}
                           }) { 
                        status
                        message   
                        }
                        }`,
            };
            const response = await upsertFBOrder(paramsInput);
            if (response) db.fbOrderData.where("fbOrderId").equals(order[i].fbOrderId).modify({ fbOrderSync: "Y" });
          }
        }
      });
  } else if (type === "getFBOrder") {
    try {
      setLoading(true);
      const paramsInput = {
        query: `query {
      getFBOrder(
        tableId: "${item?.cwrFbTableId}",
        status: "${status || item?.fbOrderStatus}"
      ) {
        fbOrderId
        cSBunitID
        isactive
        sOrderId
        fbTableId
        orderNo
        fbSectionId
        date
        guests
        guestType
        salesRepId
        guestName
        referredBy
        status
        isCanceled
        discAmount
        meta {
            key
            value
        }
        lines {
          fbOrderLineId
          line
          mPoductId
          mBatchId
          description
          csUomId
          qty
          unitPrice
          listPrice
          csTaxId
          lineTax
          lineGross
          isOrdered
          sOrderLineId
          isCanceled
          discount
          mPricingRuleId
          name
          value
          grossStd
          grossUnit
          lineStd
          netList
          netStd
          netUnit
          unitTax
          meta {
            fbOrderLineMetaId
            key
            value
          }
        }
      }
    }`,
      };

      const response = await getFBOrder(paramsInput);
      return response.data.data.getFBOrder;
    } catch (error) {
      console.error("Error while getFBOrder", error);
    } finally {
      setLoading(false);
    }
  }
};

export { SyncData };
